
const BASIC_OPTION = {
  backgroundColor: "#fff", //背景色
  title: {
    text: "单位(mg/m³)",
    subtext: "",
    x: "10px",
    y: "10px",
    textStyle: {
      color: "#666", //颜色
      fontStyle: "normal", //风格
      fontWeight: "normal", //粗细
      fontFamily: "Microsoft yahei", //字体
      fontSize: 11, //大小
      align: "center", //水平对齐
    },
  },
  legend: {
    show: false,
    // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
    orient: "horizontal",
    // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
    x: "center",
    // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
    y: "bottom",
    data: ["预期", "实际", "假设"],
  },

  //  图表距边框的距离,可选值：'百分比'¦ {number}（单位px）
  grid: {
    top: "40px", // 等价于 y: '16%'
    left: "10px",
    right: "30px",
    bottom: "14px",
    containLabel: true, //解决标签溢出
  },
  // 提示框
  tooltip: {
    trigger: "axis",
     axisPointer: {
        type: 'line',
        lineStyle: {
            color: "#7AEAFE",
            width: 2,
        },
    }
  },
  //工具框，可以选择
  toolbox: {
    show: false,
    feature: {
      saveAsImage: {}, //下载工具
    },
  },
  xAxis: {
    name: "",
    type: "category",
    axisLine: {
      lineStyle: {
        color: "#999", // 设置x轴颜色
      },
    },
    axisTick: {
      show: false, //隐藏刻度线
    },
    // 设置X轴数据旋转倾斜
    axisLabel: {
      rotate: 0, // 旋转角度
      interval: 0, //设置X轴数据间隔几个显示一个，为0表示都显示
    },
    // boundaryGap值为false的时候，折线第一个点在y轴上
    boundaryGap: false,
    data: [],
  },
  yAxis: {
    name: "",
    type: "value",
    splitNumber: 3, // 设置y轴刻度间隔个数
    splitLine: { show: false }, //去除网格线
    axisLine: {
      show: false, //隐藏坐标线
      lineStyle: {
        color: "#666", // 设置y轴颜色
      },
    },
    axisTick: {
      show: false, //隐藏刻度线
    },
  },
  series: [],
  color: ["#BB9DFF"],
};

const EMPTY_OPTION = {
  backgroundColor: "rgba(0,0,0,0.02)", //背景色
  title: {
    text: "暂无图表数据",
    subtext: "",
    x: "center",
    y: "center",
    textStyle: {
      color: "#999", //颜色
      fontStyle: "normal", //风格
      fontWeight: "normal", //粗细
      fontFamily: "Microsoft yahei", //字体
      fontSize: 14, //大小
      align: "center", //水平对齐
    },
  },
  legend: {
    show: false,
    // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
    orient: "horizontal",
    // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
    x: "center",
    // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
    y: "bottom",
    data: ["预期", "实际", "假设"],
  },

  //  图表距边框的距离,可选值：'百分比'¦ {number}（单位px）
  grid: {
    top: "40px", // 等价于 y: '16%'
    left: "10px",
    right: "30px",
    bottom: "14px",
    containLabel: true, //解决标签溢出
  },
  // 提示框
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: "#7AEAFE",
        width: 2,
      },
    },
  },
  //工具框，可以选择
  toolbox: {
    show: false,
    feature: {
      saveAsImage: {}, //下载工具
    },
  },
  xAxis: {
    name: "",
    type: "category",
    axisLine: {
      lineStyle: {
        color: "#999", // 设置x轴颜色
      },
    },
    axisTick: {
      show: false, //隐藏刻度线
    },
    // 设置X轴数据旋转倾斜
    axisLabel: {
      rotate: 0, // 旋转角度
      interval: 0, //设置X轴数据间隔几个显示一个，为0表示都显示
    },
    // boundaryGap值为false的时候，折线第一个点在y轴上
    boundaryGap: false,
    data: [],
  },
  yAxis: {
    name: "",
    type: "value",
    splitNumber: 3, // 设置y轴刻度间隔个数
    splitLine: { show: false }, //去除网格线
    axisLine: {
      show: false, //隐藏坐标线
      lineStyle: {
        color: "#666", // 设置y轴颜色
      },
    },
    axisTick: {
      show: true, //隐藏刻度线
    },
  },
  series: [
    {
      name: "预期",
      data: [],
      type: "line",
      // 注意：设置symbol: 'none'以后，拐点不存在了，设置拐点上显示数值无效
      // symbol: 'none',// 设置小圆点消失
      smooth: 0.5, // 设置折线弧度，取值：0-1之间
      symbol: "circle", // 设置拐点为实心圆
      symbolSize: 6, // 设置折线上圆点大小
    },
    {
      name: "",
      data: [],
      type: "line",
      symbolSize: 4, // 设置折线上圆点大小
      smooth: 0.5, // 设置折线弧度，取值：0-1之间
      itemStyle: {
        normal: {
          label: {
            show: true, // 拐点上显示数值
          },
          borderColor: "#f00", // 拐点边框颜色
          lineStyle: {
            width: 2, // 设置线宽
            type: "dotted", //'dotted'虚线 'solid'实线
          },
        },
      },
    },
    {
      name: "假设",
      data: [],
      type: "line",
      symbolSize: 4, // 设置折线上圆点大小
      symbol: "circle", // 设置拐点为实心圆
      itemStyle: {
        normal: {
          label: {
            show: false, // 拐点上显示数值
          },
          lineStyle: {
            // 使用rgba设置折线透明度为0，可以视觉上隐藏折线
            color: "rgba(0,0,0,0)",
          },
        },
      },
    },
  ],
  color: ["#BB9DFF", "#58D5AB", "#FF7989"],
};

export {BASIC_OPTION,EMPTY_OPTION}